import instance from "./Interceptor"

const REGISTER_USER = "v1/auth/register";
const CHECK_AVAILABIITY = "v1/auth/check-availability"
const SEND_OTP = "v1/auth/send-otp"
const VERIFY_OTP = "v1/auth/verify-otp"
const LOGIN_USER = "v1/auth/login"
const FORGOT_PASSWORD = "v1/auth/forgot-password"
const UPDATE_PASSWORD = "/v1/auth/update-password"
const ADD_PAYMENT_METHOD = "v1/stripe/add-payment-method"
const CANCEL_SUBSCRIPTION = "v1/stripe/cancel-subscription"
const GET_PRODUCT_LISTING = "v1/stripe/get-products"
const CHANGE_PLAN = "v1/stripe/change-plan"
const SCHEDULE_CALL = "v1/schedule-call"
const ADD_SUB_USER = "v1/auth/add-sub-user"
const SET_DEFAULT_SUB_USER = "v1/auth/default-user"
const GET_PAYMENT_METHODS = "v1/stripe/get-payment-method-list"
const CREATE_TRIAL_SUBSCRIPTION = "v1/stripe/create-trial-subscription"
const GET_USER_PLAN_DETAILS = "v1/auth/user-plan-details"
const RE_SCHEDULE_CALL = "v1/schedule-call/re-schedule"

export const register = (payload) => {
    return instance.post(REGISTER_USER, payload)
}

export const checkavailability = (payload) => {
    return instance.get(`${CHECK_AVAILABIITY}?${payload}`)
}

export const sendotp = (payload) => {
    return instance.post(SEND_OTP, payload)
}

export const verifyotp = (payload) => {
    return instance.post(VERIFY_OTP, payload)
}

export const loginuser = (payload) => {
    return instance.post(LOGIN_USER, payload)
}

export const forgotpassword = (payload) => {
    return instance.post(FORGOT_PASSWORD, payload)
}

export const updatepassword = (id, payload) => {
    return instance.put(`${UPDATE_PASSWORD}/${id}`, payload)
}

export const addpaymentmethod = (payload) => {
    return instance.post(ADD_PAYMENT_METHOD, payload)
}

export const cancelsubscription = () => {
    return instance.put(CANCEL_SUBSCRIPTION)
}

export const getproductisting = (limit, page) => {
    return instance.get(GET_PRODUCT_LISTING)
}

export const changeplan = (payload) => {
    return instance.put(CHANGE_PLAN, payload)
}

export const schedulecall = (payload) => {
    return instance.post(SCHEDULE_CALL, payload)
}

export const reschedulecall = (payload) => {
    return instance.post(RE_SCHEDULE_CALL, payload)
}
export const addsubuser = (payload) => {
    return instance.post(ADD_SUB_USER, payload)
}

export const setdefaultsubuser = (payload) => {
    return instance.put(SET_DEFAULT_SUB_USER, payload)
}

export const getpaymentmethods = () => {
    return instance.get(GET_PAYMENT_METHODS)
}

export const createtrialsubscription = (payload) => {
    return instance.post(CREATE_TRIAL_SUBSCRIPTION, payload)
}

export const getuserplandetails = () => {
    return instance.get(GET_USER_PLAN_DETAILS)
}